<template>
  <div ref="app" id="app" :class="$router.currentRoute.name">
    <div class="page-container" :class="classStyle">
      <md-drawer
        v-show="$mq == 'large' || $mq == 'xlarge'"
        class="notification-desktop"
        ref="notificationDrawer"
        md-right
        :md-active.sync="notificationVisible"
      >
        <notifications
          @close="notificationVisible = !notificationVisible"
        ></notifications>
      </md-drawer>
      <div
        v-if="$mq != 'large' && $mq != 'xlarge'"
        class="notification-mobile"
        :class="{ open: notificationVisible, 'full-list': isFullList }"
      >
        <notifications
          @close="notificationVisible = !notificationVisible"
          @isNotificationList="isFullList = $event"
        ></notifications>
      </div>
      <div class="app-toolbar" :class="{ 'notifications-viewed': isViewed }">
        <div class="content">
          <div class="desc-logo">
            <a href="/">
              <img :alt="logoAlt" :src="websiteLogo" />
            </a>
          </div>
          <md-menu>
            <span v-for="(item, key) in mainMenu" :key="key" :class="item.class">
              <popper
                v-if="item.menu"
                ref="popper"
                trigger="clickToToggle"
                :options="{
                  modifiers: [{ offset: { offset: '0,0' } }],
                }"
              >
                <md-button
                  @blur="menuOpen = false"
                  @click="menuOpen = !menuOpen"
                  slot="reference"
                  ref="popperTrigger"
                  :class="{
                    [item.className]:
                      item.hasOwnProperty('className') &&
                      item.className.length > 0,
                  }"
                >
                  {{ item.title }}
                  <md-icon>{{
                    menuOpen ? "arrow_drop_up" : "arrow_drop_down"
                  }}</md-icon>
                </md-button>
                <div class="popper toolbar" ref="popperContent">
                  <div class="popper-content">
                    <a
                      v-for="(item, key) in item.menu"
                      :key="key"
                      :href="getMenuItemPath(item)"
                      :target="item.target"
                      class="submenu-link"
                      >{{ item.title }}</a
                    >
                  </div>
                </div>
              </popper>
              <a
                v-else
                :href="getMenuItemPath(item)"
                :target="item.target"
                class="md-button md-theme-default"
                :class="{
                  logout: item.path == 'user/logout',
                  mobile: item.mobile,
                  active: isActive(item),
                }"
                >{{ item.title }}</a
              >
            </span>
          </md-menu>
          <div class="right">
            <popper
              v-if="hasCreateMenu"
              ref="popper"
              trigger="clickToToggle"
              :options="{
                placement: 'bottom-end',
                modifiers: [{ offset: { offset: '0,0' } }],
              }"
            >
              <md-button slot="reference" ref="popperTrigger" class="create">
                <md-icon>add_circle</md-icon>Create
              </md-button>

              <div class="popper toolbar" ref="popperContent">
                <div class="popper-content">
                  <a
                    href="/observation/add"
                    class="submenu-link"
                    v-if="hasObservation"
                    >{{ observationLabel }}</a
                  >
                  <a
                    v-if="hasAssignment"
                    href="/assignment/add"
                    class="submenu-link"
                    >{{ assignmentLabel }}</a
                  >
                </div>
              </div>
            </popper>

            <div
              class="search-bar-desk"
              v-show="$mq == 'large' || $mq == 'xlarge'"
            >
              <md-button
                v-show="!desc_search"
                class="md-icon-button search-icon"
                @click="showSearch"
              >
                <md-icon>search</md-icon>
              </md-button>
              <transition name="fade">
                <md-field v-show="desc_search" class="search">
                  <label>Search library</label>
                  <md-icon>search</md-icon>
                  <md-input
                    ref="deskSearch"
                    @keyup.enter="searchLibrary"
                    v-model="search_library"
                  ></md-input>
                  <md-button @click="searchLibrary">Go!</md-button>
                </md-field>
              </transition>
            </div>
            <md-badge>
              <md-button
                @click="notificationVisible = !notificationVisible"
                class="md-icon-button button-notification"
              >
                <md-icon>notifications</md-icon>
              </md-button>
            </md-badge>
            <md-button
              v-if="true || newCount"
              @click="notificationVisible = !notificationVisible"
              class="button-notification-count"
              >{{ newCount }} NEW</md-button
            >
          </div>
        </div>
      </div>
      <md-app md-waterfall>
        <md-app-toolbar
          class="md-primary"
          :class="
            $mq
              | mq({
                xsmall: null,
                small: null,
                medium: null,
                large: 'fb-full',
                xlarge: 'fb-full',
              })
          "
        >
          <div
            class="md-toolbar-row fb-welcome"
            v-show="$mq != 'large' && $mq != 'xlarge'"
          >
            <div class="md-toolbar-section">
              <welcome-message
                @notification-toggle="notificationToggle"
                :nid="nid"
                :routeName="$router.currentRoute.name"
                :scroll="scroll"
              ></welcome-message>
            </div>
          </div>
          <div class="md-toolbar-row header-toolbar-row">
            <div class="md-toolbar-section-start">
              <md-button
                v-if="$mq != 'large' && $mq != 'xlarge'"
                class="md-icon-button"
                @click="menuVisible = !menuVisible"
              >
                <md-icon>menu</md-icon>
              </md-button>
            </div>
            <div class="md-toolbar-section">
              <a v-if="$mq != 'large' && $mq != 'xlarge'" href="/">
                <img
                  width="30"
                  height="34"
                  :alt="logoAlt"
                  :src="websiteLogoMobile"
                />
              </a>
            </div>

            <div
              class="md-toolbar-section-end"
              :class="{ 'notifications-viewed': isViewed }"
            >
              <md-button
                v-if="$mq != 'large' && $mq != 'xlarge'"
                @click="goTo('/best-practices')"
                class="md-icon-button button-notification"
              >
                <md-icon>search</md-icon>
              </md-button>

              <md-badge>
                <md-button
                  @click="notificationVisible = !notificationVisible"
                  class="md-icon-button button-notification"
                >
                  <md-icon>notifications</md-icon>
                </md-button>
              </md-badge>
              <md-button
                v-if="newCount"
                @click="notificationVisible = !notificationVisible"
                class="button-notification-count"
                >{{ newCount }} NEW</md-button
              >
            </div>
          </div>
        </md-app-toolbar>

        <md-app-drawer
          :md-permanent="
            $mq
              | mq({
                xsmall: null,
                small: null,
                medium: null,
                large: 'full',
                xlarge: 'full',
              })
          "
          class="main-menu"
          :md-active.sync="menuVisible"
          v-if="
            ($mq != 'large' && $mq != 'xlarge') || route_array[0] == 'strategy'
          "
        >
          <div class="sidebar-strategy">
            <md-toolbar
              v-if="$mq != 'large' && $mq != 'xlarge'"
              class="md-transparent"
              md-elevation="0"
            >
              <h2>Menu</h2>
            </md-toolbar>

            <md-button
              v-if="$mq != 'large' && $mq != 'xlarge'"
              @click="menuVisible = !menuVisible"
              class="md-icon-button close"
            >
              <md-icon>close</md-icon>
            </md-button>

            <md-list
              v-if="
                route_array[0] == 'strategy' &&
                ($mq == 'large' || $mq == 'xlarge')
              "
              class="startegy-menu"
              ref="menuLeft"
            >
              <md-list-item class="desk-title">
                <span class="md-list-item-text">{{ title }}</span>
              </md-list-item>
              <md-list-item :class="{ active: tab == 'ready' }">
                <span class="md-list-item-text">
                  <a href="#ready" @click.stop.prevent="setTab('ready')">
                    Ready
                    <md-icon class="ready"></md-icon>
                  </a>
                </span>
              </md-list-item>
              <md-list-item :class="{ active: tab == 'set' }">
                <span class="md-list-item-text">
                  <a href="#set" @click.stop.prevent="setTab('set')">
                    Set
                    <md-icon class="set"></md-icon>
                  </a>
                </span>
              </md-list-item>
              <md-list-item :class="{ active: tab == 'go' }">
                <span class="md-list-item-text">
                  <a href="#go" @click.stop.prevent="setTab('go')">
                    Go
                    <md-icon class="go"></md-icon>
                  </a>
                </span>
              </md-list-item>
            </md-list>
            <md-list
              v-if="
                route_array[0] != 'strategy' ||
                ($mq != 'large' && $mq != 'xlarge')
              "
            >
              <md-list-item v-if="$mq != 'large' && $mq != 'xlarge'">
                <md-field class="search">
                  <label>Search library</label>
                  <md-icon>search</md-icon>
                  <md-input v-model="search_library"></md-input>
                  <md-button @click="searchLibrary">Go!</md-button>
                </md-field>
              </md-list-item>

              <!-- Mobile main menu. -->
              <md-list-item
                v-for="(item, key) in mainMenu"
                :key="key"
                :md-expand="item.items && item.items.length ? true : false"
                :md-expanded="item.items && item.items.length"
                :class="[{
                  logout: item.path == 'user/logout',
                  mobile: item.mobile,
                  active: isActive(item),
                }, item.class]"
              >
                <span class="md-list-item-text">
                  <a
                    v-if="!item.items || !item.items.length"
                    :href="getMenuItemPath(item)"
                    :target="item.target"
                  >
                    {{ item.title }}
                    <md-icon v-if="item.icon">{{ item.icon }}</md-icon>
                  </a>
                  <span class="expanded-title" v-else>{{ item.title }}</span>
                </span>
                <md-list v-if="item.items" slot="md-expand">
                  <md-list-item
                    v-for="(subitem, subkey) in item.items"
                    :key="subkey"
                    class="md-inset"
                  >
                    <a
                      :href="getMenuItemPath(subitem)"
                      :target="subitem.target"
                      >{{ subitem.title }}</a
                    >
                  </md-list-item>
                </md-list>
              </md-list-item>
            </md-list>
          </div>
        </md-app-drawer>

        <md-app-content>
          <div
            v-if="route_array[0] != 'profile' && route_array[0] != 'quiz'"
            class="fb-welcome desc md-small-hide"
          >
            <welcome-message
              :nid="nid"
              :status="activity_status"
              :routeName="$router.currentRoute.name"
              v-show="$mq == 'large' || $mq == 'xlarge'"
              :class="{ large: $mq == 'large' || $mq == 'xlarge' }"
              @notification-toggle="notificationToggle"
            ></welcome-message>
          </div>
          <div ref="highlighted" class="md-content md-theme-default"></div>
          <router-view
            @set-nid="nid = $event"
            :tab="tab"
            :nid="nid"
            :mode="true"
            :content="true"
            @change-status="activity_status = $event"
            @tab-change="tabChange"
          />
        </md-app-content>
      </md-app>
    </div>
    <div class="footer">
      <span
        >© {{ new Date().getFullYear() }} Trinity Education Group, Inc.</span
      >
      <a target="_blank" href="/terms">Terms</a>
      <a target="_blank" :href="helpCenterUrl">Help Center</a>
    </div>
  </div>
</template>

<script>
import WelcomeMessage from "./components/WelcomeMessage.vue";
import Notifications from "./components/Notifications";
import _ from "lodash";
import { initializeFirebase } from "./pushNotifications";

import MenuMixin from "./MenuMixin";
import Popper from "vue-popperjs";
import "vue-popperjs/dist/vue-popper.css";

export default {
  name: "App",
  created() {
    initializeFirebase();
  },
  mixins: [MenuMixin],
  data: () => ({
    menuOpen: false,
    sidebarOffset: {
      top: 163,
    },
    activity_status: null,
    suuid: null,
    helpCenterUrl:
      window.drupalSettings.group_catch_config.labels.help_center_link,
    user: window.drupalSettings.user,
    desc_search: false,
    scroll: null,
    menuVisible: false,
    notificationVisible: false,
    newCount: window.drupalSettings.notifications
      ? window.drupalSettings.notifications.newCount
      : 0,
    title: window.drupalSettings.node ? window.drupalSettings.node.title : "",
    classStyle: "",
    nid: null,
    search_library: "",
    isViewed: window.drupalSettings.notifications.newCount == 0,
    isFullList: 0,
    route_array: [],
    tab: "ready",
    websiteTitle: window.drupalSettings.website.title,
    websiteLogo: window.drupalSettings.website.logo,
    websiteLogoMobile: window.drupalSettings.website.logo_mobile,
    logoAlt: window.drupalSettings.website.logo + " logo",
    assignmentLabel: window.drupalSettings.group_catch_config.labels.assignment_label || "",
    observationLabel: window.drupalSettings.group_catch_config.labels.observation_label,
  }),
  computed: {
    hasCreateMenu() {
      if (window.drupalSettings.user.role != "coach") {
        return false;
      }
      return this.hasObservation || this.hasAssignment;
    },
    hasObservation() {
      let groupSettings = window.drupalSettings.user.group_settings;
      if (groupSettings) {
        if (groupSettings.observation === "1") {
          return true;
        }
      }
      return false;
    },
    hasAssignment() {
      let groupSettings = window.drupalSettings.user.group_settings;
      if (groupSettings) {
        if (groupSettings.assignments === "1") {
          return true;
        }
      }
      return false;
    },
    mainMenu() {
      return this.getMainMenu(this.$mq).filter(item => {
        if (item.items) {
          item.items = item.items.filter(subitem => {
            if (subitem.restricted) {
              return subitem.access.call();
            } else {
              return true;
            }
          })
        }
        if (item.restricted) {
          return item.access.call();
        } else {
          return true;
        }
      });
    },
  },
  mounted() {
    if (window.drupalSettings.form_builder) {
      let nodes = Object.keys(window.drupalSettings.form_builder);
      if (nodes.length) {
        this.nid = nodes[0];
      }
    }
    let wrapper = window.document.querySelector("body");
    // Mutation observer
    const observer = new MutationObserver((mutationsList, observer) => {
      for (let mutation of mutationsList) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "style"
        ) {
          this.sidebarOffset = {
            top: 84 + wrapper.style.paddingTop,
          };
        }
      }
    });
    const config = { attributes: true };
    observer.observe(wrapper, config);
    this.$refs["deskSearch"] && this.$refs["deskSearch"].$el.addEventListener("blur", this.blurSearch);
    let header = document.querySelector("header");
    let tabs = document.querySelector(".tabs.primary");
    let notificationDrawer = this.$refs.notificationDrawer;
    if (notificationDrawer) {
      let mdApp = document.querySelector("#app .md-app");
      mdApp.insertBefore(this.$refs.notificationDrawer.$el, mdApp.firstChild);
    }
    if (header) this.$refs.highlighted.appendChild(header);
    if (tabs) this.$refs.highlighted.appendChild(tabs);
    let self = this;
    var lastScrollTop = 0;
    var scheduledAnimationFrame;

    function readAndUpdatePage() {
      scheduledAnimationFrame = false;
    }

    var throttled = _.throttle(() => {
      if (scheduledAnimationFrame) {
        return;
      }
      let className = "";
      let scrolled = window.pageYOffset || document.documentElement.scrollTop;
      let height = document.querySelector(".fb-welcome")
        ? document.querySelector(".fb-welcome").offsetHeight
        : 0;
      if (scrolled < 0) {
        scrolled = 0;
        lastScrollTop = 0;
      }
      if (
        scrolled &&
        scrolled + window.innerHeight >= document.body.scrollHeight
      ) {
        scrolled = lastScrollTop;
      }
      if (scrolled && scrolled >= lastScrollTop) {
        self.scroll = "downscroll";
      } else {
        self.scroll = "upscroll";
      }
      className = self.scroll;
      if (scrolled) {
        className += " scrolled";
      }
      if (self.classStyle != className) {
        self.classStyle = className;
      }

      lastScrollTop = scrolled < 0 ? 0 : scrolled;
      scheduledAnimationFrame = true;
      requestAnimationFrame(readAndUpdatePage);
    }, 100);
    window.addEventListener("scroll", throttled);
    this.route_array = window.location.pathname.split("/").splice(1);

    if (this.$refs.popperTrigger && this.$refs.popperTrigger.forEach) {
      this.$refs.popperTrigger.forEach((trg) => {
        let trigger = trg.$el;
        let parent = trigger.parentNode;
        parent.insertBefore(trigger, parent.firstChild);
      });
    }
    else if (this.$refs.popperTrigger && this.$refs.popperTrigger.$el) {
      let trigger = this.$refs.popperTrigger.$el;
      let parent = trigger.parentNode;
      parent.insertBefore(trigger, parent.firstChild);
    }

  },
  components: {
    Notifications,
    WelcomeMessage,
    Popper,
  },
  methods: {
    log(msg) {
      console.log(msg);
    },
    isActive(item) {
      let route = window.location.pathname.split("/").splice(1);
      if (item.items) {
          for (let k=0; k < item.items.length; k++) {
            if (route[0] ==  item.items[k].path) {
              return true;
            }
        }
      }
      return route[0] == item.path ||
      (route[0] == 'activity-submission' &&
        item.path == 'submissions')
    },
    searchLibrary() {
      //this.$router.push('/best-practices');
      window.location.href = "/best-practices?s=" + this.search_library;
    },
    getMenuItemPath(item) {
      if (item.menu) {
        item = item.menu[0];
      }
      return item.external ? item.path : "/" + item.path;
    },
    setTab(id) {
      // Clear autosave id tab is changed.
      clearInterval(window.autosave);
      if (id == this.tab) {
        if (this.$route.path.match(/(error|thanks)/)) {
          this.tab = "";
        } else {
          return;
        }
      }
      setTimeout(() => {
        this.tab = id;
      }, 0);
      if (document.querySelector(".md-app-scroller")) {
        document.querySelector(".md-app-scroller").scrollTop = 0;
      }
      window.scrollTop = 0;
    },
    tabChange(event) {
      if (this.tab != event) {
        this.tab = event;
      }
    },
    goTo(url) {
      window.location.href = url;
    },
    blurSearch() {
      if (this.desc_search) {
        this.desc_search = false;
      }
    },
    showSearch() {
      this.desc_search = true;
      setTimeout(() => {
        this.$refs["deskSearch"].$el.focus();
        this.$refs["deskSearch"].$el.setSelectionRange(0, 0);
      }, 100);
    },
    notificationToggle() {
      this.notificationVisible = !this.notificationVisible;
    },
  },
};
</script>
<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateX(100%);
}
</style>
<style lang="scss">

.expanded-title {
  color: #ffffff;
  display: inline-block;
  padding-left: 30px;
  font-weight: 600;
}
.main-menu {
  .md-list-item-expand.md-list-item-expand {
    border-top: none;
    border-bottom: none;
    .md-icon.md-theme-default.md-icon-font {
      display: none;
      width: 85px;
      &.md-icon.md-theme-default.md-icon-image svg {
        fill: #ffffff;
      }
    }
  }
  .md-list-item {
    .md-list {
      .md-list-item.md-list-item {
        a {
          font-weight: 300;
          padding-left: 50px;
        }
      }
    }
  }
}
</style>
